module.exports = __webpack_public_path__ + "static/media/avocado.3fc55e2a.png";